import React from "react";
import Input from "../Input";
import Button from "../Button";
import "./index.less";
export default ({ field, value = [], placeholder, onChange }) => {
  const _onChange = (item, newValue) => {
    let data = [];
    if (!item) {
      data = [{ name: newValue }];
    } else {
      item.name = newValue;
      data = [...value];
    }
    onChange(data);
  };

  const _onAdd = () => {
    let data = [...value];
    data.push({ name: "" });
    onChange(data);
  };

  const _onRemove = (index) => {
    let data = [...value];
    data.splice(index, 1);
    onChange(data);
  };

  return (
    <span className="TUI-InputObjArray">
      {value.length > 0 ? (
        value.map((item, index) => (
          <span className={"TUI-InputObjArray-Item"} key={index}>
            <Input
              key={field + "__" + index}
              name={field + "__" + index}
              value={item.name}
              placeholder={placeholder || "请输入"}
              onChange={(value) => _onChange(item, value)}
            />
            {index === 0 ? (
              <Button onClick={_onAdd}>+</Button>
            ) : (
              <Button onClick={() => _onRemove(index)}>-</Button>
            )}
          </span>
        ))
      ) : (
        <span className="TUI-InputObjArray-Item">
          <Input
            name={field}
            placeholder={placeholder || "请输入"}
            onChange={(value) => _onChange(null, value)}
          />
          <Button onClick={_onAdd}>+</Button>
        </span>
      )}
    </span>
  );
};
